'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _wixrestProperties = require('@wix/wixrest-properties');

var _wixrestProperties2 = _interopRequireDefault(_wixrestProperties);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _OrderItem = require('./OrderItem.js');

var _OrderItem2 = _interopRequireDefault(_OrderItem);

var _openrest4js = require('openrest4js');

var _ChargeV = require('./ChargeV2.js');

var _ChargeV2 = _interopRequireDefault(_ChargeV);

var _CurrencyUtils = require('../CurrencyUtils.js');

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

var _PhoneUtils = require('../PhoneUtils.js');

var _PhoneUtils2 = _interopRequireDefault(_PhoneUtils);

var _FutureDelivery = require('./FutureDelivery');

var FutureDelivery = _interopRequireWildcard(_FutureDelivery);

var _Utils = require('../Utils.js');

var _Utils2 = _interopRequireDefault(_Utils);

var _Properties = require('../Properties');

var _Properties2 = _interopRequireDefault(_Properties);

var _GoogleMapsUtils = require('../GoogleMapsUtils.js');

var _User = require('./User');

var _User2 = _interopRequireDefault(_User);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChargeHelper = _openrest4js.helpers.Charge;

var self = {};

self.calculateTotalOrderWithoutCoupons = function (params) {
    var order = params.order;
    if (!order) return 0;

    var orderItems = params.order.orderItems || [];

    var total = 0;
    for (var i = 0; i < orderItems.length; i++) {
        var orderItem = order.orderItems[i];
        total += _OrderItem2.default.getTotalPrice(orderItem);
    }

    return total;
};

self.getAllApplicableCharges = function (params) {
    var order = params.order;
    var charges = params.charges;
    var clubIds = params.clubIds;
    var ref = params.ref;
    var timezone = params.timezone;

    var res = [];

    for (var i in charges) {
        var charge = charges[i];
        if (ChargeHelper.isApplicable({
            charge: charge, orderItems: order.orderItems,
            clubIds: clubIds, ref: ref, timezone: timezone, deliveryType: order.delivery.type })) {
            res.push(charges[i]);
        }
    }

    return res;
};

self.getAllApplicableChargesV2 = function (params) {
    var order = params.order,
        chargesV2 = params.chargesV2,
        clubIds = params.clubIds,
        timezone = params.timezone;


    var deliveryTime = (0, _moment2.default)(order.delivery.time).tz(timezone);

    return _lodash2.default.reject(chargesV2, function (charge) {
        return !_ChargeV2.default.isDisplayable({ charge: charge, orderItems: order.orderItems, platform: order.platform,
            deliveryTime: deliveryTime, clubIds: clubIds, deliveryType: order.delivery.type });
    });
};

self.calculateTotalOrder = function (params) {
    var order = params.order;
    var charges = params.charges;
    var chargesV2 = params.chargesV2 || order.chargesV2;
    var withoutTax = params.withoutTax;
    var timezone = params.timezone;
    var orderCharges = params.orderCharges;

    var deliveryTime = (0, _moment2.default)(order.delivery.time).tz(timezone);

    var total = self.calculateTotalOrderWithoutCoupons(params);
    var price = 0;

    var charges = self.getAllApplicableCharges(params);
    for (var i in charges) {
        var charge = charges[i];
        if (charge.type == 'coupon' || charge.type == 'club_coupon') {
            price += ChargeHelper.calculateAmount({ charge: charge, orderItems: order.orderItems, maxDiscount: total, extraCost: 0 });
        }
        if (!withoutTax && charge.type == 'tax') {
            price += ChargeHelper.calculateAmount({ charge: charge, orderItems: order.orderItems, maxDiscount: total, extraCost: 0 });
        }
    }

    _lodash2.default.each(chargesV2, function (charge) {
        if (charge.type != 'tax' || !withoutTax) {
            price += _ChargeV2.default.calculateAmount({ charge: charge, orderItems: order.orderItems, platform: order.platform,
                deliveryTime: deliveryTime, deliveryType: order.delivery.type });
        }
    });

    _lodash2.default.each(orderCharges, function (orderCharge) {
        return price += orderCharge.amount;
    });

    return total + price;
};

self.getOrderTax = function (params) {
    var order = params.order;
    var charges = params.charges;
    var chargesV2 = params.chargesV2;
    var orderCharges = params.orderCharges;
    var total = self.calculateTotalOrderWithoutCoupons(params);
    var price = 0;
    var found = false;

    _lodash2.default.each(charges, function (charge) {
        if (charge.type == 'tax') {
            found = true;
            price += ChargeHelper.calculateAmount({ charge: charge, orderItems: order.orderItems, maxDiscount: total, extraCost: 0 });
        }
    });

    _lodash2.default.each(chargesV2, function (charge) {
        if (charge.type == 'tax' && charge.state !== 'closed') {
            found = true;
            var orderCharge = _lodash2.default.find(orderCharges, function (o) {
                return o.chargeId === charge.id;
            });
            price += (orderCharge || {}).amount || 0;
        }
    });

    return found ? price : null;
};

function transformOrderItemToRestaurant(params) {
    var orderItem = params.orderItem;
    var itemMapping = params.itemMapping;
    var destItemsMapping = params.destItemsMapping;

    orderItem.itemId = itemMapping[orderItem.itemId];

    var item = destItemsMapping[orderItem.itemId];

    for (var i in orderItem.variations) {
        orderItem.variations[i] = JSON.parse((0, _stringify2.default)(item.variations[i]));
    }

    for (var i in orderItem.variationsChoices) {
        for (var j in orderItem.variationsChoices[i]) {
            orderItem.variationsChoices[i][j] = transformOrderItemToRestaurant({
                orderItem: orderItem.variationsChoices[i][j],
                itemMapping: itemMapping,
                destItemsMapping: destItemsMapping
            });
        }
    }

    return orderItem;
}

function transformChargesToRestaurant(params) {
    var order = params.order;
    var destRestaurantFull = params.destRestaurantFull;

    var oldCharges = JSON.parse((0, _stringify2.default)(order.charges));
    order.charges = self.getCharges({ order: order, charges: destRestaurantFull.charges, timezone: destRestaurantFull.restaurant.timezone });

    for (var i = 0, l = order.charges.length; i < l; i++) {
        var destCharge = order.charges[i];
        var type = destCharge.amountRuleType || 'variable';
        if (type === 'variable') {
            for (var j = 0, l2 = oldCharges.length; j < l2; j++) {
                var srcCharge = oldCharges[j];
                var srcType = srcCharge.amountRuleType || 'variable';
                if (srcType === type && srcCharge.clubId === destCharge.clubId && srcCharge.coupon.title[window.spiceI18n.locale] === destCharge.coupon.title[window.spiceI18n.locale]) {
                    destCharge.amount = srcCharge.amount;
                }
            }
        }
    }

    return order;
}

self.getCharges = function (params) {
    var order = params.order;
    var charges = params.charges;
    var timezone = params.timezone;

    var ret = [];
    var total = self.calculateTotalOrderWithoutCoupons({ order: order });
    var charges = self.getAllApplicableCharges({
        order: order, charges: charges, clubIds: (order.clubMember || {}).clubIds,
        ref: order.ref, timezone: timezone
    });

    for (var i in charges) {
        var charge = charges[i];
        charge.amount = ChargeHelper.calculateAmount({ charge: charge, orderItems: order.orderItems,
            maxDiscount: total, extraCost: 0
        });

        ret.push(charge);
    }

    return ret;
};

self.getChargesV2 = function (params) {
    var order = params.order;
    var chargesV2 = params.chargesV2;
    var timezone = params.timezone;
    var deliveryTime = (0, _moment2.default)(order.delivery.time).tz(timezone);

    var ret = [];
    var charges = self.getAllApplicableChargesV2({
        order: order, chargesV2: chargesV2, clubIds: (order.clubMember || {}).clubIds,
        ref: order.ref, timezone: timezone
    });

    var ret = _lodash2.default.map(charges, function (charge) {
        charge.amount = _ChargeV2.default.calculateAmount({ charge: charge, orderItems: order.orderItems, platform: order.platform,
            deliveryTime: deliveryTime, deliveryType: order.delivery.type });
        return charge;
    });

    return ret;
};

self.transformOrderToRestaurant = function (params) {
    var order = params.order;
    var srcRestaurantFull = params.srcRestaurantFull;
    var destRestaurantFull = params.destRestaurantFull;
    var chainId = srcRestaurantFull.chain.id;

    order.restaurantId = destRestaurantFull.restaurant.id;

    var destItemsMapping = {};
    for (var i in destRestaurantFull.menu.items) {
        var item = destRestaurantFull.menu.items[i];
        destItemsMapping[item.id] = item;
    }

    var destItemMappingToExternalId = {};
    for (var i in destRestaurantFull.menu.items) {
        var item = destRestaurantFull.menu.items[i];
        var id = (item.externalIds || {})[chainId] || null;

        if (id !== null) {
            destItemMappingToExternalId[id] = item.id;
        } else if (!item.inactive) {
            console.log("No mapping for " + item.title["he_IL"] + " " + id + " " + "(" + destRestaurantFull.restaurant.title["he_IL"] + ")");
        }
    }

    var itemMapping = {};
    for (var i in srcRestaurantFull.menu.items) {
        var item = srcRestaurantFull.menu.items[i];
        var id = (item.externalIds || {})[chainId] || null;

        if (id !== null && destItemMappingToExternalId[id] && destItemsMapping[destItemMappingToExternalId[id]]) {
            itemMapping[item.id] = destItemMappingToExternalId[id];
            if (item.title["he_IL"] !== destItemsMapping[destItemMappingToExternalId[id]].title["he_IL"]) {
                console.log("'" + id + "' " + item.title["he_IL"] + "(" + srcRestaurantFull.restaurant.title["he_IL"] + ") - " + destItemsMapping[destItemMappingToExternalId[id]].title["he_IL"] + "(" + destRestaurantFull.restaurant.title["he_IL"] + ")");
            }
        } else if (id === null && !item.inactive) {
            console.log("No mapping for " + item.title["he_IL"] + " " + id + " (" + srcRestaurantFull.restaurant.title["he_IL"] + ")");
        } else if (!item.inactive) {
            console.log("No connection for " + item.title["he_IL"] + " " + id + " (" + srcRestaurantFull.restaurant.title["he_IL"] + ")", destItemMappingToExternalId[id]);
        }
    }

    for (var i in order.orderItems) {
        order.orderItems[i] = transformOrderItemToRestaurant({
            orderItem: order.orderItems[i],
            itemMapping: itemMapping,
            destItemsMapping: destItemsMapping
        });
    }

    order = transformChargesToRestaurant({ order: order, destRestaurantFull: destRestaurantFull });
};

self.getOrderExtraData = function (order) {
    var ret = {};

    ret.displayStatus = order.status;
    if (order.status === "accepted" && order.delivered) {
        ret.displayStatus = "delivered";
    }

    var cancellationReason = self.getCancellationReason(order);

    if (cancellationReason) ret.cancellationReason = cancellationReason;

    // Returns an array of color codes, used in: order pane stripe, order pane text, order details title, order details title buttons
    ret.colors = ({
        "new": "#5fb0f5 #3899ec #3899ec #74b8f2",
        "accepted": "#81da78 #60bc57 #60bc57 #90d08a",
        "delivered": "#cfebcc #60bc57 #80c979 #a6d9a1",
        "canceled": "#f1726b #ee5951 #ee5951 #f38b86"
    }[ret.displayStatus || 'new'] || "#ffffff #ffffff #ffffff #ffffff").split(/ /g);

    var userExtraData = _User2.default.getUserExtraData(order.user);
    ret.isFacebookUser = userExtraData.isFacebookUser;
    ret.urlPicture = userExtraData.urlPicture;

    //var prepareTime = parseInt(OPU.get(OrganizationStore.getData(), Properties.OrderProperties.DELIVERED) || "0");

    return ret;
};

self.getCancellationReason = function (order) {
    if (order.status === "canceled") {
        var cancellationEntry = (0, _lodash2.default)(order.log).filter(function (l) {
            return _lodash2.default.startsWith(l.comment, 'canceled');
        }).last();

        if (cancellationEntry) {
            var match = /canceled \[(.*?)\]/.exec(cancellationEntry.comment);

            if (match) return match[1];
        }
    }
};

self.getDelayMins = function (order) {
    var timeGuarantee = (order.delivery || {}).timeGuarantee || 'before';
    var deliveryTime = (0, _moment2.default)((order.delivery || {}).time);
    var delayMins = null;

    switch (timeGuarantee) {
        case 'before':
            if (order.submitAt) {
                delayMins = deliveryTime.diff((0, _moment2.default)(order.submitAt), "m");
            } else if (order.received) {
                delayMins = deliveryTime.diff((0, _moment2.default)(order.received), "m");
            } else {
                // WTF?
                delayMins = deliveryTime.diff((0, _moment2.default)(order.created), "m");
            }
            break;
        case 'about':
            break;
    }

    return delayMins;
};

self.isPreorder = function (order) {
    return order.submitAt > 0;
};

self.isFutureOrder = function (order) {
    return (order.delivery || {}).timeGuarantee === "about";
};

self.isAsap = function (order) {
    return !this.isPreorder(order) && !this.isFutureOrder(order);
};

/**
 * Returns the order in the displayable format shown below.
 *
 * @param order         The order to display
 * @param title         The title to put in the top of the order
 * @param itemsHash     Hash between itemId and item (from menu).
 * @param chargesHash   Hash between chargeId and charge (from menu).
 * @param menuFull      Used to create itemsHash & chargesHash if they are not given (optional otherwise).
 * @param organization  The organization (used for currency, timezone, and pickup address)
 * @param iconPhone     The icon (WixRestIcon name) to show for phone (has default, no real need to change this)
 * @param iconLocation  The icon (WixRestIcon name) to show for location (has default, no real need to change this)
 * @param iconClock     The icon (WixRestIcon name) to show for clock (pickup/delivery time) (has default, no real need to change this)
 * @param iconMail      The icon (WixRestIcon name) to show next to the email (has default, no real need to change this)
 * @param iconFb        The icon (WixRestIcon name) to show next to FB (has default, no real need to change this)
 * @param i18n          The i18n taken from wixrest-utils.
 * @param Creditcards   'import {Creditcards} from 'creditcards-info';' Received as param for optimizations.
 * @param Gatways       'import {Gateways} from 'payments';' Received as param for optimization.
 *
 * @return The following data structure:
 *      {
 *          cart:{
 *
 *              // Header for cart
 *              header:{
 *                  title: '...',   // Title to show on top of the cart (As given in parameters).
 *                  subtitle: '...' // Subtitle to show on top of the cart. Currently '(X items)'.
 *              },
 *
 *              // List of items in the cart
 *              items: [
 *                  ...             // List of the following data structure:
 *                  {
 *                      count: 1,                       // Number of times this item is in the list
 *                      price: '$9,000',                // String of the price to show
 *                      title: 'My Cool Item',          // Title of the item ot show
 *                      variations: [
 *                          ...                         // List of the following data structore
 *                          {
 *                              title: 'Addons:',       // Title of variation
 *                              text: 'eggs, dinosaurs ($3), without zombies, without bugs',
 *                          },
 *                          ...
 *                      ],
 *                  }
 *                  ...
 *
 *              // Order comments
 *              comment:{
 *                  title:'...',                        // "Kitchen requests"
 *                  text:'...',                         // The actual comment
 *              }
 *
 *              // List of charges (to display all! no filtering needed!)
 *              charges:[
 *                  ...                                 // List of the following data structure:
 *                  {
 *                      title:'...',
 *                      description:'...',
 *                      amount:'-$3,500'
 *                  }
 *                  ...
 *              ],
 *
 *              // List of summary lines
 *              summary: {
 *
 *                  // List of extra lines/charges including: Subtotal, tax, delivery
 *                  extras: [
 *                        ...
 *                        {
 *                            title:'...',
 *                            price:'$9,000',
 *                        }
 *                        ...
 *                   ],
 *
 *                   // The last total to display
 *                   total: {
 *                        title: 'Total' // (localized of course)
 *                        text: '$9,450',
 *                    }
 *                },
 *          }
 *
 *          // That was the cart area, now the rest of the information
 *
 *          // Delivery information needed to display a map
 *          delivery: {
 *                    mapLink: {
 *                        text: '...',              // Map overlay caption
 *                        url: '...'                // Link to google map
 *                    }
 *          },
 *
 *          // User information to display on top
 *          user: {
 *                    profileLink: null | '...',        // Url to user profile
 *                    profilePicture: null | '...',     // Url to user image
 *                    fullName:'...'                    // User full name
 *          },
 *
 *          // List of details to display row by row.
 *          details: [
 *                    ...           // Can be one of the following (icon, line, or parts):
 *
 *                    {
 *                          type: 'icon',                   // ROW WITH ICON
 *                          icon: 'phoneOutline',           // One of the WixRestIcon names
 *                          link: 'tel:+972523816135',      // Link when clicked
 *                          text: '052-381-6135'            // Actual text to display
 *                    }
 *
 *                    {
 *                          type: 'line',                   // ROW WITHOUT ICON (often subrow to the above row with icon)
 *                          title: 'Postalcode',            // Title to display
 *                          text: '67337'                   // Text to display (shows as Postalcode: 67337)
 *                    }
 *
 *                    {
 *                          type: 'parts',                  // ROW WHICH SHOULD BE DIVIDED TO MULTIPLE PARTS
 *                          parts: [
 *                              ...                         // List of the following data structure:
 *                              {
 *                                  text: '78',             // Will be displayed Apt: 78
 *                                  title: 'Apt'
 *                              }
 *                              ...
 *                          ]
 *                    }
 *                    ...
 *          ],
 *
 *          // List of payments to display
 *          payments: {
 *                    title: '...'              // Title to show on top 'Pay with:'
 *                    payments: [
 *                          ...
 *                          {
 *                              title: "MasterCard **** 1234",              // Title for payment
 *                              amount: "$9,350",                           // Amount paid
 *                              description:null | 'Charged by phone',      // Extra information
 *                          }
 *                          ...
 *                    ]
 *          }
 *      }
 *
 */
self.getDisplayableOrder = function (params) {
    var _details$push;

    var _params$order = params.order,
        order = _params$order === undefined ? {} : _params$order,
        title = params.title,
        menuFull = params.menuFull,
        locale = params.locale,
        organization = params.organization,
        _params$viewMode = params.viewMode,
        viewMode = _params$viewMode === undefined ? 'customer' : _params$viewMode,
        _params$cardStyle = params.cardStyle,
        cardStyle = _params$cardStyle === undefined ? 'minimal' : _params$cardStyle,
        _params$iconPhone = params.iconPhone,
        iconPhone = _params$iconPhone === undefined ? 'phoneOutline' : _params$iconPhone,
        _params$iconLocation = params.iconLocation,
        iconLocation = _params$iconLocation === undefined ? 'locationOutline' : _params$iconLocation,
        _params$iconClock = params.iconClock,
        iconClock = _params$iconClock === undefined ? 'clockOutline' : _params$iconClock,
        _params$iconMail = params.iconMail,
        iconMail = _params$iconMail === undefined ? 'mailOutline' : _params$iconMail,
        _params$iconFb = params.iconFb,
        iconFb = _params$iconFb === undefined ? 'facebookOutline' : _params$iconFb,
        i18n = params.i18n,
        Creditcards = params.Creditcards,
        Gateways = params.Gateways;
    var itemsHash = params.itemsHash,
        chargesHash = params.chargesHash;


    if (!itemsHash) {
        itemsHash = _lodash2.default.zipObject(_lodash2.default.map(menuFull.items, 'id'), menuFull.items);
    }

    if (!chargesHash) {
        chargesHash = _lodash2.default.zipObject(_lodash2.default.map(menuFull.chargesV2, 'id'), menuFull.chargesV2);
    }

    // Helper function
    var currencize = function currencize(amount) {
        return _CurrencyUtils2.default.toStr(_Utils2.default.padPrice(amount || 0), organization.currency, locale);
    };
    var L = function L(localized) {
        return localized ? localized[i18n.getLocale()] || localized[organization.locale] || _lodash2.default.values(localized)[0] : null;
    };

    // ---- CART HEADER - Title (given in props) & Subtitle
    var numItems = _lodash2.default.sumBy(order.orderItems, function (o) {
        return o.count || 1;
    });
    var cartHeader = {
        title: title,
        subtitle: numItems === 1 ? i18n.get('openrest_cartview_numitem', '(1 item)') : i18n.get('openrest_cartview_numitems', '(${params.num} items)', { params: { num: numItems } })
    };

    // ---- CART ITEMS - Adds the list of items
    var items = _lodash2.default.map(order.orderItems, function (orderItem) {

        // Use flatten version of the orderItem
        var _OrderItemHelper$flat = _OrderItem2.default.flattenVariations({ orderItem: orderItem }),
            variations = _OrderItemHelper$flat.variations,
            variationsChoices = _OrderItemHelper$flat.variationsChoices;

        // Create a full order item from the flatten version


        var orderItemWithVariations = (0, _extends3.default)({}, orderItem, { variations: variations, variationsChoices: variationsChoices });
        var fullOrderItem = _OrderItem2.default.getFullOrderItem({ orderItem: orderItemWithVariations, itemsHash: itemsHash });

        // Get the variations structure

        return {
            count: fullOrderItem.count,
            title: L(fullOrderItem.title),
            price: currencize(fullOrderItem.count * fullOrderItem.priceEach),
            variations: _OrderItem2.default.itemVariationsAndCommentToStructure({ fullOrderItem: fullOrderItem, stringifyMoney: currencize, i18n: i18n, localizedToStr: L, viewMode: viewMode })
        };
    });

    // ---- CART DISCOUNTS - Adding all charges (that are not delivery/tax)
    var orderCharges = _lodash2.default.map(order.orderCharges, function (orderCharge) {
        return (0, _extends3.default)({}, chargesHash[orderCharge.chargeId], { amount: orderCharge.amount });
    });
    var groupChargesById = _lodash2.default.groupBy(orderCharges, function (c) {
        return _Properties2.default.get(c, 'groupId') || Math.random();
    });

    var charges = _lodash2.default.compact(_lodash2.default.union([],

    // New charges (chargesV2)
    _lodash2.default.map(groupChargesById, function (group) {
        var charge = group[0];
        var amount = _lodash2.default.sumBy(group, 'amount');
        if (charge.type === 'tax') return null;
        if (charge.type === 'tip') return null;
        return {
            title: L(charge.title || (charge.coupon || {}).title),
            description: L(charge.description || (charge.coupon || {}).description),
            amount: currencize(amount)
        };
    }),

    // Old charges (charges)
    _lodash2.default.map(order.charges, function (charge) {
        if (charge.type === 'tax') return null;
        if (charge.type === 'tip') return null;
        return {
            title: ChargeHelper.getTitle({ charge: charge, i18n: i18n, defaultLocale: organization.locale }),
            description: ChargeHelper.getDescription({ charge: charge, i18n: i18n, defaultLocale: organization.locale }),
            amount: currencize(charge.amount)
        };
    })));

    // ---- CART SUMMARY LINES - Subtotal, delivery, total
    var subtotal = _lodash2.default.sum(_lodash2.default.map(order.orderItems, function (item) {
        return _OrderItem2.default.getTotalPrice(item);
    }));
    subtotal += _lodash2.default.sum(_lodash2.default.map(order.orderCharges, function (charge) {
        return chargesHash[charge.chargeId].type === 'tax' || chargesHash[charge.chargeId].type === 'tip' ? 0 : charge.amount || 0;
    })); // Taxes and tips are displayed at the end after subtotal
    subtotal += _lodash2.default.sum(_lodash2.default.map(order.charges, function (charge) {
        return charge.type === 'tax' ? 0 : charge.amount;
    })); // Taxes are displayed at the end after subtotal

    var taxes = _lodash2.default.union([], _lodash2.default.filter(order.orderCharges, function (charge) {
        return chargesHash[charge.chargeId].type === 'tax';
    }), _lodash2.default.filter(order.charges, function (charge) {
        return charge.type === 'tax';
    }));

    var extras = [];

    extras.push({ title: i18n.get('openrest_checkoutconfirmationview_subtotal', 'Subtotal'), price: currencize(subtotal || 0) });

    if (!_lodash2.default.isEmpty(taxes)) {
        extras.push({
            title: i18n.get('openrest_checkoutconfirmationview_tax'),
            price: currencize(_lodash2.default.sum(_lodash2.default.map(taxes, 'amount')) || 0)
        });
    }

    if (order.delivery && order.delivery.type === 'delivery') {
        extras.push({
            title: i18n.get('openrest_checkoutconfirmationview_delivery'),
            price: order.delivery.charge ? currencize(order.delivery.charge) : i18n.get('openrest_checkoutconfirmationview_free')
        });
    }

    var tip = _lodash2.default.find(order.orderCharges, function (charge) {
        return chargesHash[charge.chargeId].type === 'tip';
    });
    if (tip && tip.amount > 0) {
        extras.push({
            title: i18n.get('openrest_checkoutconfirmationview_tip'),
            price: currencize(tip.amount),
            borders: true
        });
    }

    var summary = {
        extras: extras,
        total: {
            title: i18n.get('openrest_checkoutconfirmationview_total', 'Total'),
            text: currencize(order.price)
        }
    };

    var cart = {
        header: cartHeader,
        chargesTitle: i18n.get('openrest_checkoutconfirmationview_charges_title', 'Applied Discounts'),
        items: items,
        charges: charges,
        summary: summary

        // ---- CART COMMENT - Adds the order comment
    };if (order.comment) {
        var cartTitle = _Properties2.default.get(organization, _wixrestProperties2.default.RestaurantProperties.OLO.KITCHEN_REQUESTS_PLACEHOLDER) || i18n.get('openrest_checkoutconfirmationview_kitchen_comment');

        cart.comment = {
            title: cartTitle,
            text: order.comment
        };
    }

    // ---- ORDER DETAILS - Delivery map
    var mapLink = null;
    if ((order.delivery || {}).address || organization.address) {
        var address = (order.delivery || {}).address ? order.delivery.address : organization.address;
        mapLink = (0, _GoogleMapsUtils.buildLocalizedGoogleMapsUrl)(i18n, { ie: 'UTF8', ll: address.latLng.lat + ',' + address.latLng.lng, q: address.formatted });
    }

    var delivery = {
        mapLink: {
            url: mapLink,
            text: i18n.get('openrest_checkoutconfirmationview_overlay_caption')
        }
    };

    if (!!_Properties2.default.get(order, 'wixrest.olo.contactlessDelivery')) {
        delivery.isContactlessDelivery = true;
    }

    // ---- ORDER DETAILS - User (FB link, FB picture, full name)
    var orderExtra = this.getOrderExtraData(order);
    var user = {
        profileLink: orderExtra.isFacebookUser ? 'https://www.facebook.com/' + order.user.clientId.id : null,
        profilePicture: orderExtra.isFacebookUser ? orderExtra.urlPicture : null,
        fullName: (order.contact || {}).firstName + ' ' + (order.contact || {}).lastName

        // ---- ORDER DETAILS - List of details to show
    };var details = [];
    details.push({
        type: 'icon',
        text: _PhoneUtils2.default.displayPhone(_lodash2.default.get(order, 'contact.phone'), organization.address.countryCode) || '',
        ariaLabel: i18n.get('openrest_checkoutcontactview_phonenumber', 'Phone Number'),
        icon: iconPhone,
        link: 'tel:' + _lodash2.default.get(order, 'contact.phone'),
        ltr: true
    });

    var deliveryText = function () {
        var type = _lodash2.default.get(order, 'delivery.type');
        switch (type) {
            case 'delivery':
                return _lodash2.default.get(order, 'delivery.address.formatted') || '';
            case 'takeout':
                return i18n.get('openrest_checkoutconfirmationview_takeout', 'Pickup');
            case 'premises':
                return i18n.get('openrest_checkoutconfirmationview_premises', 'Premises (${params.where})', {
                    params: {
                        where: JSON.parse((order.delivery.properties || {})['com.wixrestaurants'] || '{}')['premises.where']
                    }
                });
            default:
                return 'Unknown';
        }
    }();

    var deliveryAria = function () {
        var type = _lodash2.default.get(order, 'delivery.type');
        switch (type) {
            case 'delivery':
                return i18n.get('openrest_checkoutconfirmationview_deliveryaddress', 'Delivery address');
            case 'takeout':
                return i18n.get('openrest_checkoutconfirmationview_takeout', 'Pickup');
            case 'premises':
                return i18n.get('openrest_checkoutconfirmationview_premises', 'Premises (${params.where})', {
                    params: {
                        where: JSON.parse((order.delivery.properties || {})['com.wixrestaurants'] || '{}')['premises.where']
                    }
                });
            default:
                return 'Unknown';
        }
    }();

    details.push({
        type: 'icon',
        text: deliveryText,
        ariaLabel: deliveryAria,
        icon: iconLocation || 'locationOutline',
        link: mapLink
    });

    _lodash2.default.get(order, 'delivery.address.postalCode') && details.push({
        type: 'line',
        title: i18n.get('openrest_checkoutconfirmationview_postalcode'),
        text: _lodash2.default.get(order, 'delivery.address.postalCode')
    });

    var deliveryAddressParts = _lodash2.default.filter([{
        title: i18n.get('openrest_checkoutconfirmationview_apt'),
        text: _lodash2.default.get(order, 'delivery.address.apt')
    }, {
        title: i18n.get('openrest_checkoutconfirmationview_floor'),
        text: _lodash2.default.get(order, 'delivery.address.floor')
    }, {
        title: i18n.get('openrest_checkoutconfirmationview_entrance'),
        text: _lodash2.default.get(order, 'delivery.address.entrance')
    }], function (x) {
        return !!x.text;
    });

    _lodash2.default.size(deliveryAddressParts) && details.push({
        type: 'parts',
        parts: deliveryAddressParts
    });

    _lodash2.default.get(order, 'delivery.address.comment') && details.push({
        type: 'line',
        title: i18n.get('openrest_checkoutconfirmationview_delivery_instructions'),
        text: _lodash2.default.get(order, 'delivery.address.comment')
    });

    _lodash2.default.get(order, 'delivery.address.onArrival') && details.push({
        type: 'line',
        title: i18n.get('openrest_checkoutconfirmationview_on_arrival'),
        text: _lodash2.default.get(order, 'delivery.address.onArrival') == 'buzz' ? i18n.get('openrest_checkoutconfirmationview_on_arrival_buzz') : i18n.get('openrest_checkoutconfirmationview_on_arrival_phone')
    });

    var getOrderTimeGuaranteeText = FutureDelivery.timeGuaranteeText.getOrderTimeGuaranteeText;


    var deliveryTimeText = params.deliveryTimeText || getOrderTimeGuaranteeText(order, function (token, params) {
        return i18n.get(token, 'ASAP (up to ${params.delayMins})', params);
    }, organization.timezone);

    details.push({
        type: 'icon',
        text: deliveryTimeText,
        ariaLabel: i18n.get('openrest_checkoutconfirmationview_deliverytime', 'Delivery Time'),
        icon: iconClock
    });

    _lodash2.default.get(order, 'contact.email') && details.push((_details$push = {
        type: 'icon',
        ariaLabel: "openrest_checkoutconfirmationview_customer_email[undefined]",
        text: _lodash2.default.get(order, 'contact.email')
    }, (0, _defineProperty3.default)(_details$push, 'ariaLabel', i18n.get('openrest_checkoutconfirmationview_customer_email', 'Customer Email')), (0, _defineProperty3.default)(_details$push, 'icon', iconMail), (0, _defineProperty3.default)(_details$push, 'link', 'mailto:' + _lodash2.default.get(order, 'contact.email')), _details$push));

    _lodash2.default.get(order, 'user.clientId.id') && viewMode === 'restaurant' && details.push({
        type: 'icon',
        text: _lodash2.default.get(order, 'contact.firstName') + ' ' + _lodash2.default.get(order, 'contact.lastName'),
        ariaLabel: i18n.get('openrest_checkoutconfirmationview_customer_name', 'Customer Name'),
        icon: iconFb,
        link: 'https://www.facebook.com/' + _lodash2.default.get(order, 'user.clientId.id')
    });

    // ---- ORDER DETAILS - Payments
    var payments = {
        title: i18n.get('openrest_checkoutconfirmationview_paying_with', 'Paying with:'),
        payments: _lodash2.default.map(order.payments, function (payment) {

            var paymentType = i18n.get('openrest_checkoutconfirmationview_cash', 'Cash');
            var method = null;
            var network = 'cash';

            if (payment.type === 'il.co.mysodexo') {
                network = 'cibus';
                paymentType = i18n.get('openrest_checkoutconfirmationview_cibus_title', 'Cibus #${params.number}', { params: { number: (payment.card || {}).number || '' } });

                if (!_lodash2.default.isEmpty(payment.externalIds)) {
                    var key = _lodash2.default.keys(payment.externalIds)[0];
                    method = i18n.get('openrest_checkoutconfirmationview_cibus_description', 'Confirmation: ${params.transactionId}', { params: { transactionId: payment.externalIds[key] } });
                }
            } else if (payment.type === 'credit' || payment.type === 'cashier' && payment.paymentMethod === 'credit') {
                paymentType = i18n.get('openrest_checkoutconfirmationview_credit_card');
                if (payment.collectionMethod == 'phone') {
                    method = i18n.get('openrest_checkoutconfirmationview_payment_method_phone');
                    network = 'card';
                } else if (payment.collectionMethod == 'cod') {
                    network = 'card';
                    method = i18n.get('openrest_checkoutconfirmationview_payment_method_cod');
                } else if (payment.collectionMethod == 'online' || payment.type === 'cashier') {

                    if (payment.type === 'cashier') {
                        payment = (0, _extends3.default)({}, payment, {
                            cardToken: payment.cardToken || { creditCard: payment.creditCard }
                        });
                    }

                    network = _lodash2.default.get(payment, 'cardToken.creditCard.network');
                    if (!_lodash2.default.isEmpty(payment.externalIds)) {
                        var _key = _lodash2.default.keys(payment.externalIds)[0];
                        if (_key !== 'cashier') {
                            method = Gateways.getGatewayDisplayName(function (token) {
                                return i18n.get(token, _key);
                            }, _key) + ': ' + payment.externalIds[_key];
                        }
                    }

                    if (payment.cardToken && payment.cardToken.creditCard) {
                        if (cardStyle === 'full') {
                            paymentType = Creditcards.getCreditcardName(i18n.getLocale(), payment.cardToken.creditCard.network) + ' {{' + payment.cardToken.token + '}} (' + payment.cardToken.creditCard.expiration.month + '/' + payment.cardToken.creditCard.expiration.year + ')';

                            var additionalFields = payment.cardToken.creditCard.additionalFields || {};
                            var sortedAdditionalFieldPairs = (0, _lodash2.default)(additionalFields).toPairs().filter(function (a) {
                                return a[1];
                            }).sortBy(function (a) {
                                return Creditcards.getFieldSortValue(a[0]);
                            }).value();

                            method = _lodash2.default.map(sortedAdditionalFieldPairs, function (a) {
                                return Creditcards.getFieldName(i18n.getLocale(), a[0]) + ': ' + a[1];
                            }).join(', ');
                        } else {
                            paymentType = Creditcards.getCreditcardName(i18n.getLocale(), payment.cardToken.creditCard.network) + ' **** ' + payment.cardToken.creditCard.lastDigits;
                        }
                    }
                }
            } else if (payment.type === 'cashier') {
                network = payment.paymentMethod;
                paymentType = payment.paymentMethodTitle;
            }

            var amount = currencize(payment.amount);

            return {
                title: paymentType,
                amount: amount,
                description: method,
                network: network
            };
        })
    };

    var infoToDisplay = {
        cart: cart,
        delivery: delivery,
        user: user,
        details: details,
        payments: payments
    };

    if (orderExtra.cancellationReason) infoToDisplay.cancellationReason = orderExtra.cancellationReason;

    return infoToDisplay;
};

self.getOrderCharges = _openrest4js.helpers.Order.getOrderCharges;

exports.default = self;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/Order.js
// module id = 287
// module chunks = 0